import { MutationHookOptions, useMutation } from '@apollo/client';

import { START_EVALUATION } from './mutations';

export const useStartEvaluation = (options?: MutationHookOptions) => useMutation(START_EVALUATION, options);
